import { NovoPlanoRenegociacao } from './novo-plano-renegociacao.model';

export interface PlanosPorTipo {
  QUITACAO: NovoPlanoRenegociacao[];
  PARCELADO: NovoPlanoRenegociacao[];
}

export class MapaPlanosPorOrigem {
  CYBER: PlanosPorTipo;
  ESPECIAL: PlanosPorTipo;

  constructor() {
    this.CYBER = { PARCELADO: [], QUITACAO: [] };
    this.ESPECIAL = { PARCELADO: [], QUITACAO: [] };
  }
}
